import { FormattedMessage } from 'react-intl';
import {
  FIELD_AMOUNT,
  FIELD_MEMBERS,
  FIELD_MEMBER_SELECTED,
  FIELD_INTEREST_RATE,
  COMMON_FIELD_NAMES,
} from './constants.fields';

export const MSG_TREASURIES = 'afforda.assets.details.treasuries';

export const TREASURY_FIELD_NAMES = {
  memberId: COMMON_FIELD_NAMES.memberId,
  amount: COMMON_FIELD_NAMES.amount,
  interestRate: COMMON_FIELD_NAMES.interestRate,
  feesToConvertCash: COMMON_FIELD_NAMES.feesToConvertCash,
};

export const FIELDS = ({ intl, members, disabledMembers }) => {
  return [
    ...FIELD_MEMBERS({ members, disabledMembers }),
    // Amount
    {
      ...FIELD_MEMBER_SELECTED,
      ...FIELD_AMOUNT,
      label: <FormattedMessage id="afforda.assets.details.treasuries.amount" />,
      placeholder: intl.formatMessage({
        id: 'afforda.assets.details.amount',
      }),
      name: TREASURY_FIELD_NAMES.amount,
    },
    // Interest Rate
    {
      ...FIELD_MEMBER_SELECTED,
      ...FIELD_INTEREST_RATE,
      label: (
        <FormattedMessage id="afforda.assets.details.treasuries.interestRate" />
      ),
      placeholder: '0.00',
      name: TREASURY_FIELD_NAMES.interestRate,
      helperText: (
        <FormattedMessage id="afforda.assets.details.treasuries.interestRateHelperText" />
      ),
      GridProps: {
        xs: 12,
        sm: 6,
      },
      rules: { ...FIELD_INTEREST_RATE.rules, required: false },
    },
    // Fees to Convert to Cash
    {
      ...FIELD_MEMBER_SELECTED,
      ...FIELD_AMOUNT,
      label: (
        <FormattedMessage id="afforda.assets.details.treasuries.feesToConvertCash" />
      ),
      placeholder: '0.00',
      name: TREASURY_FIELD_NAMES.feesToConvertCash,
      helperText: (
        <FormattedMessage id="afforda.assets.details.treasuries.feesToConvertCashHelperText" />
      ),
      rules: { ...FIELD_AMOUNT.rules, required: false },
    },
  ];
};
